import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { AssignFormValues } from "../components/CaseActionBar";

export const assignValidationSchema = () => {
  const { t } = useTranslation();

  return yup.object().shape({
    chamberUser: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    message: yup.string(),
  });
};
